import { Icon } from "@/components/Icon";

const FooterItem = ({ textColor, content, index = 0 }) => {
  const {
    title = "",
    footerLinkText = "",
    footerText = "",
    link = "",
    icon = "",
  } = content;

  const getTextColor = (textColor) => {
    switch (textColor) {
      case "blue-dark":
        return "text-blue-dark";
      case "gray-300":
        return "xl:text-white text-blue-dark";
      default:
        return "xl:text-white text-blue-dark";
    }
  };
  const getTextColorSubtext = (textColor) => {
    switch (textColor) {
      case "blue-dark":
        return "text-blue-dark";
      case "gray-300":
        return "xl:text-gray-300 text-gray-600";
      default:
        return "xl:text-gray-300 text-blue-dark";
    }
  };
  return (
    <div
      className={`flex flex-row flex-wrap  gap-y-3 ${
        index === 2 ? "xl:col-span-2 xl:max-w-[60%]" : ""
      }`}
    >
      {title && (
        <p className={`${getTextColor(textColor)} font-bold flex flex-row `}>
          {icon && <BildIcon />}
          {title}
        </p>
      )}
      {footerText && (
        <p className={`${getTextColorSubtext(textColor)} text-[14px]`}>
          {footerText}
        </p>
      )}

      <a href={link}>
        <div className="text-blue-light  cursor-pointer flex items-center gap-4 mt-4 border-b-2 border-transparent hover:border-blue-light">
          {footerLinkText}
          <Icon type="chevron" className="h-4 w-4 text-blue-light" />
        </div>
      </a>
    </div>
  );
};
export default FooterItem;

const BildIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="22"
      fill="none"
      className="mr-4"
    >
      <path
        fill="#D91918"
        fill-rule="evenodd"
        d="M0 0h20.105v22H0V0Z"
        clip-rule="evenodd"
      />
      <path
        fill="#fff"
        fill-rule="evenodd"
        d="M10.482 18.822h1.98V2.768h-1.98v16.054ZM6.79 17.95a.865.865 0 0 1-.862.866H2.026V2.768h3.906c.47 0 .856.386.857.866v5.625c0 .453-.371.82-.825.82h-.086c.501 0 .911.407.911.908v6.963ZM4.005 4.75h.812v4.573h-.812V4.749Zm0 6.538h.812v5.542h-.812v-5.542Zm14.074 7.534V2.767H16.1V5.56h-1.925a.862.862 0 0 0-.856.866l-.002 11.523c.001.48.387.865.862.866l3.901.006Zm-1.978-11.3h-.813v9.308h.813V7.522ZM7.647 4.75h1.979V2.768h-1.98v1.981Zm0 14.073h1.979V5.562h-1.98v13.26Z"
        clip-rule="evenodd"
      />
    </svg>
  );
};
